import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'ngx-header-faktury-button',
  templateUrl: './header-faktury-button.component.html',
  styleUrls: ['./header-faktury-button.component.scss']
})
export class HeaderFakturyButtonComponent {

  constructor(private router: Router) {}

  navigateToFaktury(event?: Event): void {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    
    this.router.navigate(['pages/platnosci'], {
      queryParams: { hideSummary: true }
    });
  }
}
